import { useLocalization } from '@/services/localizationService';
import { EditorPipelineStepStyle } from '@/services/editorService';
import { badgeTypes } from '@/ui/badge';
import { EditorButton } from '@/ui/editorButton';
import equal from 'fast-deep-equal';

export default function EditorFilters({
  className,
  onSelectedFilter,
  selectedModel,
  tool,
  editorModels,
}: {
  className?: string;
  onSelectedFilter: ({ tool, model }: { tool: string; model: object }) => void;
  tool: string;
  selectedModel: object;
  editorModels: EditorPipelineStepStyle[];
}) {
  const { data } = useLocalization();

  return (
    <div
      className={`filters-container flex justify-start items-center flex-wrap ${className}`}
    >
      {editorModels.map((style) => (
        <EditorButton
          key={style.key}
          id={style.key}
          value={style.value}
          label={style.title}
          active={equal(style.value, selectedModel)}
          disabled={style.disabled}
          isBadgeHidden={false}
          badge={
            style.disabled
              ? {
                  id: badgeTypes.BadgeVariants.Soon,
                  label: data.result.soon,
                }
              : undefined
          }
          onClick={() =>
            onSelectedFilter({
              tool,
              model: style.value,
            })
          }
        />
      ))}
    </div>
  );
}
